var otpFunctions = require('biba/otpfunctions');

// GyFTR checkout handling - start

if( !$('.nav-link.gyftr-tab').hasClass('active') ) {
    $('.gyftr-payment').addClass('d-none');
}

$(document).on('click', '.payment-options a', function (e) {
    let paymentMethod = $(this).closest('.nav-item').data('method-id');
    if (paymentMethod === 'GyFTR') {
        $('.gyftr-payment').removeClass('d-none');
    } else {
        $('.gyftr-payment').addClass('d-none');
    }
});


$(document).on('keypress', '.gyftr-payment input', function(event) {
    if (event.keyCode == '13') {
        event.preventDefault(); // Prevents the default Enter key behavior
    }
});

$(document).on('click', '.gyftr-phone-wrapper button', function (e) {
    e.preventDefault();
    let gyftrPhoneEl = $('.gyftr-phone-wrapper');
    let serializeData = gyftrPhoneEl.find('input').serialize();
    let otpFormEl = $('.listvouchers-otp-form');
    let feedbackErrorMsg = gyftrPhoneEl.find('.invalid-feedback');
    feedbackErrorMsg.hide();
    $.spinner().start();
    $.ajax({
        url: gyftrPhoneEl.data('url'),
        type: 'POST',
        dataType: 'json',
        data: serializeData,
        success: function (data) {
            if (data.success) {
                otpFormEl.removeClass('d-none');
                gyftrPhoneEl.addClass('disabled');

                otpFunctions.timerEvent();
                otpFunctions.otpInputs();
                otpFunctions.handleAutoFillOTP();
            } else {
                // show error
                feedbackErrorMsg.text(data.message).show();
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$(document).on('click', '.listvouchers-otp-form button', function (e) {
    e.preventDefault();
    let otpFormEl = $('.listvouchers-otp-form');
    let serializeData = otpFormEl.find('input').serialize();
    let feedbackErrorMsg = otpFormEl.find('.invalid-feedback');
    feedbackErrorMsg.hide();
    $.spinner().start();
    $.ajax({
        url: otpFormEl.data('url'),
        type: 'POST',
        dataType: 'json',
        data: serializeData,
        success: function (data) {
            if (data.success) {
                $('.gyftr-payment-wrapper').addClass('d-none');
                $('#gyftr-voucher-content').removeClass('d-none').html(data.renderedTemplate);
            } else {
                // show the error
                feedbackErrorMsg.text(data.message).show();
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$(document).on('click', '.gyftr-voucher-list-container .voucher-apply-btn', function (e) {
    e.preventDefault();
    let element = $(this);
    let voucherItem = $(this).closest('.voucher-item-row');
    let wrapper = $(this).closest('.gyftr-voucher-list-wrapper');
    let serializeData = voucherItem.find('input').serialize();

    let feedbackErrorMsg = $('.gyftr-voucher-list-container').find('.invalid-feedback');
    feedbackErrorMsg.hide();

    let feedbackMsg = $('.gyftr-voucher-list-container').find('.js-feedback-msg');
    // let successmsg= $('.js-voucher-number').attr('data-success-msg');
    
    if( !voucherItem.hasClass('add-voucher-code') ) {
        voucherItem.find('.gyftr-voucher-list-item').addClass('disabled');
    }

    $.ajax({
        url: voucherItem.data('url'),
        type: 'post',
        data: serializeData,
        success: function (data) {
            if (data.success) {
                $('#gyftrEPAYBal').text(data.updatedEPayBal.formatted);
                
                if (data.voucherType === 'E') {
                    // voucher add
                    let countEle = $('span.voucher-count');
                    countEle.text(parseInt(countEle.text()) - 1);

                    voucherItem.closest('.gyftr-voucher-list-wrapper').find('.applied-msg').remove();
                    element.closest('.gyftr-voucher-list-wrapper').find('.invalid-feedback').remove();
                    
                    let appliedmsg = `<div class="applied-msg"><i class="fa fa-check"></i> ${data.message}</div>`;
                    
                    voucherItem.closest('.gyftr-voucher-list-wrapper').append(appliedmsg);
                    element.closest('.js-btn-wrapper').find('.invalid-feedback').removeClass('d-block').addClass('d-none');
                    
                    setTimeout(function() {
                        wrapper.remove();
                        let voucherList = $('.gyftr-voucher-list-wrapper');
                        if (voucherList.length === 0)  {
                            $('.js-show-more-voucher').remove();
                        }
                    }, 5000);

                } else {
                    // enter voucher
                    voucherItem.find('input[name=voucherNumber]').val('');
                    feedbackMsg.text(data.message).addClass('success').removeClass('d-none invalid-feedback');
                }

                if (data.updatedEPayBal.value > 0) {
                    $('button.gyftr-redeem-otp').removeClass('disabled');
                }

            } else {
                // handle Error Case
                
                if (data.voucherType === 'E') { 
                    var msg = 'Something went wrong. Please try again.';
                    element.closest('.gyftr-voucher-list-wrapper').find('.invalid-feedback').remove();
                    element.closest('.gyftr-voucher-list-wrapper').append('<div class="invalid-feedback d-block error text-right">' + msg + '</div>');

                    setTimeout(function() {
                        voucherItem.find('.gyftr-voucher-list-item').removeClass('disabled');
                        element.closest('.gyftr-voucher-list-wrapper').find('.invalid-feedback').remove();
                    }, 5000);

                } else {
                    voucherItem.find('.gyftr-voucher-list-item').removeClass('disabled');
                    feedbackMsg.text(data.message).addClass('invalid-feedback').addClass('d-block');
                }
            }
        },
        error: function () {
            voucherItem.find('.gyftr-voucher-list-item').removeClass('disabled');
        }
    });
});

$(document).on('click', '.gyftr-redeem-otp', function (e) {
    e.preventDefault();
    let actionUrl = $(this).data('url');
    let feedbackErrorMsg = $('.gyftr-voucher-list-container').find('.invalid-feedback');
    feedbackErrorMsg.hide();
    $.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'post',
        success: function (data) {
            if (data.success) {
                $('.gyftr-redemption-content > div').addClass('d-none');
                $('.gyftr-payment div.gyftr-redemption-opt-form').removeClass('d-none');
    
                otpFunctions.timerEvent();
                otpFunctions.otpInputs();
                otpFunctions.handleAutoFillOTP();
            } else {
                // Show Error
                feedbackErrorMsg.text(data.message).show();
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});


$(document).on('click', '.gyftr-redeem-otp-form button', function (e) {
    e.preventDefault();
    let gyftrRedeemOTPEl = $('.gyftr-redeem-otp-form');
    let serializeData = gyftrRedeemOTPEl.find('input').serialize();
    let actionUrl = gyftrRedeemOTPEl.data('url');
    let feedbackErrorMsg = gyftrRedeemOTPEl.find('.invalid-feedback');
    feedbackErrorMsg.hide();
    $.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'POST',
        data: serializeData,
        success: function (data) {
            if (data.success) {
                updateGyFTRTotals(data.totals);
                $('.gyftr-payment > div').addClass('d-none');
                if (data.hasSufficientBal) {
                    $('#gyftr-content a.submit-payment').removeClass('disabled');
                    $('#gyftr-content').closest('form').find('.incomplete-payment').addClass('d-none');
                } else {
                    $('#gyftr-content').closest('form').find('.incomplete-payment').removeClass('d-none');
                }
                $('.gyftr-payment div.gyftr-applied-content').removeClass('d-none');
            } else {
                // show errors
                feedbackErrorMsg.text(data.message).show();
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$(document).on('click', '.gyftr-remove-btn', function (e) {
    e.preventDefault();
    let thisObj = $(this);
    let actionUrl = `${thisObj.data('url')}`;
    $.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'post',
        success: function (data) {
            updateGyFTRTotals(data.totals)
            resetGyFTRPaymentSection();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

function resetGyFTRPaymentSection () {
    // Reset all the forms
    $('.gyftr-payment > div').addClass('d-none');
    $('.gyftr-payment div.gyftr-payment-wrapper')
        .removeClass('d-none')
        .find('.gyftr-phone-wrapper')
        .removeClass('disabled');
    $('.listvouchers-otp-form').addClass('d-none');
    $('#gyftr-content a.submit-payment').addClass('disabled');
    $('#gyftr-content').closest('form').find('.incomplete-payment').addClass('d-none');
}

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateGyFTRTotals(totals) {
    $('.grand-total-sum').text(totals.appliedGyFTRTotal.value === 0 ? totals.grandTotal : totals.grandTotalAfterGyFTRApplied);

    if (totals.appliedGyFTRTotal.value > 0) {
        $('.order-total-gyftr-applied').removeClass('d-none');
        $('.gyftr-applied-amount').text('- ' + totals.appliedGyFTRTotal.formatted);
    } else {
        $('.order-total-gyftr-applied').addClass('d-none');
    }
}

// GyFTR checkout handling - end

/* toggle vouchers */
$(document).on('click', '.js-show-more-voucher', function() {
    let $this = $(this);
    let voucherList = $('.gyftr-voucher-list-wrapper');
    if(voucherList.hasClass('d-none')) {
        voucherList.removeClass('d-none');
        $this.find('.show-btn').addClass('d-none');
        $this.find('.hide-btn').removeClass('d-none');
    } else {
        voucherList.addClass('d-none')
        $('.gyftr-voucher-list-wrapper:lt(3)').removeClass('d-none');
        $this.find('.show-btn').removeClass('d-none');
        $this.find('.hide-btn').addClass('d-none');
    }
    if (voucherList.length <= 3)  {
        $('.js-show-more-voucher').remove();
    }
});
